import {Observable} from 'rxjs';
import {List} from 'immutable';

import {combineEpics} from 'web-app/util/redux-observable';
import Employee from 'web-app/react/entities/employees/model';
import EmployeeApi from 'web-app/api/employee-api';

import * as Actions from './actions';

const fetchRoles = action$ =>
    action$.ofType(Actions.fetchEmployees.type).mergeMap(({payload}) =>
        Observable.zip(EmployeeApi.fetchAllEmployees(payload.institutionId, true))
            .map(([employees]) =>
                Actions.fetchEmployeesSuccess.action(List(employees).map(Employee.fromAPI), payload.institutionId),
            )
            .catch(e => Observable.of(Actions.fetchEmployeesFailed.action(e))),
    );

export default combineEpics(fetchRoles);
